import { createActionGroup, emptyProps } from "@ngrx/store";

export const SignInActions = createActionGroup({
	source: "Sign In Page",
	events: {
		"Get Latest App Version": emptyProps(),
	},
});
